<script setup lang="ts">
import BottomSheet from '@ui/components/bottom-sheet/BottomSheet.vue'
import Button from '@ui/components/button/Button.vue'
import TimePicker from '@ui/components/time-picker/TimePicker.vue'
import { ButtonVariant, Sizes } from '@ui/styles'

withDefaults(
  defineProps<{
    label?: string
    description?: string
    options?: number[]
    step?: number
    loop?: boolean
    saveDisabled?: boolean
    cancelLabel?: string
    saveLabel?: string
  }>(),
  {
    label: 'general.time',
    loop: true,
    cancelLabel: 'general.cancel',
    saveLabel: 'general.save',
  },
)

const emit = defineEmits<{
  cancel: []
  save: []
}>()

const show = defineModel<boolean>('show', { required: true })
const selectedTime = defineModel<number>({ required: true })
</script>

<template lang="pug">
BottomSheet(v-model:show="show" headerAlign="center" :label="label" :description="description" :closable="false" :snapPoints="[390]")
  .flex.col-0.overflow-hidden(@click.stop)
    TimePicker(v-model="selectedTime" :label="label" :options="options" :step="step" :loop="loop")
  template(#actions)
    Button.flex-1(:label="cancelLabel" :variant="ButtonVariant.Secondary" :size="Sizes.HanSolo" @click="emit('cancel')")
    Button.flex-1(:label="saveLabel" :variant="ButtonVariant.Primary" :size="Sizes.HanSolo" :disabled="saveDisabled" @click="emit('save')")
</template>
